<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0.931640625,7.209414662265778C0.931640625,7.209414662265778,7.839880625,9.091764662265778,7.839880625,9.091764662265778C7.839880625,9.091764662265778,9.722230625,15.990564662265777,9.722230625,15.990564662265777C9.722230625,15.990564662265777,15.990440625,0.9317646622657776,15.990440625,0.9317646622657776C15.990440625,0.9317646622657776,0.931640625,7.209414662265778,0.931640625,7.209414662265778C0.931640625,7.209414662265778,0.931640625,7.209414662265778,0.931640625,7.209414662265778Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Geolocation',
} as DefineComponent
</script>
